/* eslint-disable react/prop-types */
import React, { Component, useState } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Collapse
} from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Layout from 'components/Layout';
import Markup from 'components/Markup';
import PageTitle from 'components/PageTitle';
import Paginate from 'components/Paginate';
import PageContainer, { Wrap } from 'components/PageContainer';
import ThreeBounce from 'components/ThreeBounce';
import TimeAgo from 'components/TimeAgo';
import prismic from '../prismic';
import { fetchPublications } from 'actions/prismic';
import i18n from 'i18n';

class Publications extends Component {
  static async getInitialProps({ store, req, lang, query: { page = 1 } }) {
    return store.dispatch(
      fetchPublications({
        lang,
        page,
        pageSize: 20,
        orderings: '[my.publication.published_date desc]'
      })
    );
  }

  render() {
    const { publications, ...rest } = this.props;
    const total = publications.total_results_size;
    const { meta, description, results } = prismic.publications(publications);
    const resultsPending = (results || []).filter((r) => r.pending);
    const resultsPublished = (results || []).filter((r) => !r.pending);
    const page = rest.url.query.page;
    return (
      <Layout meta={meta} {...rest}>
        <PageContainer>
          <PageTitle>{meta.title}</PageTitle>
          <Wrap>
            {!!description && <Markup intro>{description}</Markup>}
            <PendingPublications publications={resultsPending} />
            {resultsPublished.map((pub) => (
              <Publication publication={pub} key={pub.uid} />
            ))}
            {publications.loading && (
              <ThreeBounce className="w-100 mx-auto py-5" />
            )}
            {total > 20 && (
              <div className="my-5 d-flex justify-content-center">
                <Paginate
                  current={parseInt(page || 1)}
                  total={total}
                  perPage={20}
                />
              </div>
            )}
          </Wrap>
        </PageContainer>
      </Layout>
    );
  }
}

Publications.propTypes = {
  publications: PropTypes.object
};

function Publication({ publication }) {
  if (!publication) return null;
  const kb = Math.round(((publication.document || {}).size || 0) / 1000);

  return (
    <Card className="mb-3 px-3">
      <CardBody>
        <CardText tag="div">
          <TimeAgo date={publication.published_on} />
        </CardText>
        <CardTitle tag="h5">{publication.name}</CardTitle>
        <Markup className="card-text">{publication.body}</Markup>
        {!!publication.document && !!publication.document.url && (
          <a href={publication.document.url} className="btn btn-primary">
            {/* eslint-disable-next-line prettier/prettier */}
            <i className="far fa-file-pdf" />{' '}
            {i18n.t('DOWNLOAD_PUBLICATION')} ({kb} kB)
          </a>
        )}
      </CardBody>
    </Card>
  );
}

function PendingPublications({ publications }) {
  if (!publications || publications.length === 0) return null;
  const [collapse, setCollapse] = useState(true);

  return (
    <Card className="mb-3 px-3 bg-light text-muted">
      <CardBody>
        <CardText tag="div">{i18n.t('EXPECTED')}</CardText>
        <CardTitle className="mb-0" tag="h5">
          {publications[0].name}
          {!!collapse && (
            <Button
              color="light"
              size="sm"
              className="ml-2 text-muted"
              onClick={() => setCollapse(false)}>
              {i18n.t('AND_OTHER_PUBLICATIONS', {
                count: publications.length - 1
              })}
            </Button>
          )}
        </CardTitle>
        <Collapse isOpen={!collapse}>
          {publications.slice(1).map((pub) => (
            <CardTitle className="mb-0" tag="h5" key={pub.uid}>
              {pub.name}
            </CardTitle>
          ))}
        </Collapse>
      </CardBody>
    </Card>
  );
}

export default connect(({ prismic }) => ({
  publications: prismic.publications
}))(Publications);
